import React, { useEffect } from "react";
import AOS from "aos";
import "./Project.css"; // Import the CSS file
import bloganise from "../../assets/bloganise.PNG";
import dern from "../../assets/dern.png";
import iconic from "../../assets/iconic.PNG";
import alfarouq from "../../assets/alfarouq.PNG";
import hhrd from "../../assets/hhrd app.png";
import askme from "../../assets/askme.png";

const skillData = {
  "Node.js": {
    alt: "Node.js",
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
  },
  Flutter: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg",
    alt: "Flutter",
  },
  Firebase: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-original.svg",
    alt: "Firebase",
  },
  HTML: {
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    alt: "HTML",
  },
  CSS: {
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    alt: "CSS",
  },
  JavaScript: {
    src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-plain.svg",
    alt: "JavaScript",
  },
  Tailwind: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg",
    alt: "Tailwind CSS",
  },
  Bootstrap: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
    alt: "Bootstrap",
  },
  React: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    alt: "React",
  },
  Redux: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redux/redux-original.svg",
    alt: "Redux",
  },
  ".Net Core": {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/dotnetcore/dotnetcore-original.svg",
    alt: ".Net Core",
  },
  NodeJs: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
    alt: "NodeJs",
  },
  SQLServer: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/microsoftsqlserver/microsoftsqlserver-original-wordmark.svg",
    alt: "SQLServer",
  },
  PostgreSQL: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original-wordmark.svg",
    alt: "PostgreSQL",
  },
  Figma: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
    alt: "Figma",
  },
  Jira: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jira/jira-original.svg",
    alt: "Jira",
  },
  Canva: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/canva/canva-original.svg",
    alt: "Canva",
  },
  "VS Code": {
    src: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Visual_Studio_Code_1.18_icon.svg/1200px-Visual_Studio_Code_1.18_icon.svg.png",
    alt: "Visual Studio Code",
  },
  Git: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
    alt: "Git",
  },
  ChatGPT: {
    src: "https://cdn-icons-png.flaticon.com/512/12222/12222589.png",
    alt: "ChatGPT",
  },
  Angular: {
    src: "https://cdn.jsdelivr.net/gh/glincker/thesvg@main/public/icons/angular/default.svg",
    alt: "Angular",
  },
  Docker: {
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
    alt: "Docker",
  }
  // Add other technologies similarly...
};

const data = [
  {
    frontmatter: {
      title: "Al-Farouq",
      tech: ["Angular", ".Net Core", "SQLServer", "Docker"],
      external: "https://dev.alfarouq.uk/", // Replace with actual link
      //   github: "https://github.com/example", // Replace with actual link
      img: alfarouq,
    },
    html: "<p>A management platform for Al-Farouq Quran teaching center that digitizes student enrollment, payments, teachers, classes, and Hifz progress. Led the server side and deployment: Dockerized VPS environments, GitHub Actions CI/CD, automated SQL Server backups, and Nginx routing for frontend and API.</p>",
  },
  {
    frontmatter: {
      title: "Bloganise",
      tech: ["React", ".Net Core", "Firebase", "Figma", "Jira", "Redux"],
      external: "https://example.com", // Replace with actual link
      //   github: "https://github.com/example", // Replace with actual link
      img: bloganise,
    },
    html: `<p>A blogging platform similar to Medium, where users can register, create, tag, and share articles. Admins manage content reports, bans, and tags, with notifications for users and admins. Led a team of 5 developers throughout the project lifecycle.</p>
    <strong>- ASAC Internship</strong>`,
  },
  {
    frontmatter: {
      title: "Dern Support",
      tech: ["React", "Node.js", "PostgreSQL", "Figma"],
      external: "https://dern-support-five.vercel.app/", // Replace with actual link
      //   github: "https://github.com/example", // Replace with actual link
      img: dern,
    },
    html: "<p>A full-stack system for support services, handling customer requests, inventory management, job scheduling, and data analytics for performance tracking and decision-making.</p><strong>- ASAC Internship</strong>",
  },
  {
    frontmatter: {
      title: "Iconic",
      tech: ["React", "Node.js", "PostgreSQL", "Figma", "Jira"],
      external: "https://main--guileless-zabaione-2d61ab.netlify.app/", // Replace with actual link
      //   github: "https://github.com/example", // Replace with actual link
      img: iconic,
    },
    html: "<p>A platform for designing digital cards, where users can submit personalized cards for admin approval and interact with others by favoriting cards.  Led a team of 5 developers throughout the project lifecycle.</p><strong>- ASAC Internship</strong>",
  },
  {
    frontmatter: {
      title: "HHRD Camera",
      tech: ["Flutter", "Firebase"],
      // external: "https://example.com", // Replace with actual link
      // github: "https://github.com/example", // Replace with actual link
      img: hhrd,
    },
    html: `<p>A data entry automation app for an NGO, allowing volunteers to capture and organize photos of orphans, categorized by city and volunteer for easy download by admins.</p><strong>- Freelance</strong>`,
  },
  {
    frontmatter: {
      title: "Ask Me",
      tech: ["Flutter", "Firebase"],
      github: "https://github.com/Zaid-R/Ask_me", // Replace with actual link
      img: askme,
    },
    html: "<p>A Q&A app where users ask questions, experts respond and report content, and admins oversee the platform by managing accounts and moderating content.</p><strong>- Freelance</strong>",
  },
];

const Project = () => {
  useEffect(() => {
    AOS.refresh();
  }, []);

  const handleImageLoad = () => AOS.refresh();

  return (
    <section id="projects">
      <h2 className="heading mt-6" data-aos="fade-up">
        Projects
      </h2>

      <div>
        {data.map((project, i) => {
          const { frontmatter, html } = project;
          const { external, title, tech, github, img } = frontmatter;

          return (
            <div className="project" key={i} data-aos="fade-up">
              <div className="project-content">
                <div id="header">
                  <h5 className="project-name">
                    {external ? (
                      <a
                        href={external}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        aria-label="External Link"
                      >
                        {title}
                      </a>
                    ) : (
                      title
                    )}
                  </h5>
                  {github && (
                    <a
                      href={github}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      aria-label="GitHub Link"
                      className="github-link"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="h-6 w-6"
                      >
                        <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
                      </svg>
                    </a>
                  )}
                  {external && (
                    <a
                      href={external}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="download-button btn-codigo"
                    >
                      Check it out!
                    </a>
                  )}
                </div>
                <div
                  className="description"
                  dangerouslySetInnerHTML={{ __html: html }}
                />
                <div className="skill grid gap-3 mt-3 mb-5">
                  {tech.map((technology, i) => {
                    const skill = skillData[technology];
                    return (
                      <div key={i}>
                        <img
                          alt={skill.alt}
                          className="h-10 w-10 mx-auto mb-2"
                          src={skill.src}
                        />
                        <h5>{technology}</h5>
                      </div>
                    );
                  })}
                </div>
              </div>

              <img
                src={img}
                className="featured-img"
                alt={title}
                onLoad={handleImageLoad}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Project;
